import { LayoutType, withLayout } from 'src/hocs/withLayout'

import { Learn } from './learn'

const WrappedLearn = withLayout(LayoutType.NoPadding, Learn)

export { WrappedLearn as Learn }
